const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRProgressAccepted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-progress-accepted",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,1c7.727,0 14,6.273 14,14c-0,7.727 -6.273,14 -14,14c-7.727,0 -14,-6.273 -14,-14c-0,-7.727 6.273,-14 14,-14Zm-0,2.181c6.523,-0 11.819,5.296 11.819,11.819c0,6.523 -5.296,11.819 -11.819,11.819c-6.523,0 -11.819,-5.296 -11.819,-11.819c-0,-6.523 5.296,-11.819 11.819,-11.819Z",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.132,21.444c0.264,0.153 0.579,0.189 0.871,0.1c0.291,-0.089 0.532,-0.295 0.666,-0.569c0.872,-1.866 1.331,-3.905 1.331,-5.975c-0,-7.338 -5.646,-13.358 -12.83,-13.952c-0.3,-0.018 -0.594,0.088 -0.813,0.294c-0.218,0.206 -0.357,0.497 -0.357,0.797c-0,0.006 -0,-0.001 -0,0c0.001,0.582 0.453,1.064 1.034,1.101c6.044,0.51 10.785,5.581 10.785,11.76c0,1.739 -0.383,3.452 -1.118,5.019c-0.249,0.514 -0.063,1.139 0.431,1.425Zm-4.43,-10.418c0.184,0.193 0.298,0.455 0.298,0.743c0,0.306 -0.128,0.583 -0.333,0.779l-7.898,7.539c-0.193,0.184 -0.455,0.298 -0.743,0.298c-0.289,-0 -0.551,-0.114 -0.744,-0.299l-3.949,-3.768c-0.205,-0.197 -0.333,-0.473 -0.333,-0.779c0,-0.595 0.482,-1.077 1.077,-1.077c0.288,-0 0.551,0.113 0.744,0.298l3.205,3.059l7.154,-6.829c0.192,-0.184 0.455,-0.298 0.743,-0.298c0.306,0 0.583,0.128 0.779,0.333l0,0.001Z",
    style: {
      fill: "#f80"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRProgressAccepted);
export default __webpack_public_path__ + "static/media/iconR-progress-accepted.59a03fffc1ee52680a72b83e3e3b8c8c.svg";
export { ForwardRef as ReactComponent };